<template>
    <div
        class="items_list white has-toggle"
        id="institutions_list"
        @scroll="handleScroll"
    >
        <div v-for="group in groups"
             :id="`group-${group.employee_code}`"
             :class="{show: isShowGroup(group.employee_code)}"
             :key="`group-${group.employee_code}`"
        >
            <div class="item" @click="handleClickToggleBtn(group.employee_code)">
                <strong class="text">{{group.display_name}}</strong>
                <span class="badge group-badge"
                      :class="{'no-toggle': !canShowToggleButton(group)}"
                      v-if="getTotalUnreadMessages(group.institutions) > 0 && canShowToggleButton(group)"
                >
                    {{ getTotalUnreadMessages(group.institutions) }}
                </span>
                <span class="toggle-btn" v-if="canShowToggleButton(group)"></span>
            </div>
            
            <div class="sub-items"
                 :class="{show: !canShowToggleButton(group)}"
                 :id="`sub-items-${group.employee_code}`"
            >
                <div class="item"
                     v-for="item in group.institutions"
                     @click="handleClickInstitution(item.institution_code)"
                     :key="item.institution_code"
                >
                    <span class="text">{{item.abbreviated_name_kanji}}</span>
                    <span class="badge" v-if="item.total_unread_messages > 0">{{item.total_unread_messages}}</span>
                </div>
            </div>
        </div>

        <infinite-loading @infinite="paginate">
            <div slot="spinner" style="text-align: center">
                <img style="height: 100px;width: auto;" src="@/assets/loading.gif" alt="">
            </div>
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  // import {db} from '@/firebase'
  import _ from 'lodash'
  import {CAN_SHOW_TOGGLE_INSTITUTIONS} from '../../config/index'

  export default {
    data () {
      return {
        subscribeChatGroup: null
      }
    },
    computed: {
      ...mapGetters({
        groupEmployeeSelected: 'institution/groupEmployeeSelected',
        groups: 'institution/groups',
        currentPos: 'institution/currentPos'
      })
    },
    methods: {
      ...mapActions({
        getGroups: 'institution/getGroups',
        handleClickToggleBtn: 'institution/showGroupChildren',
        setCurrentPos: 'institution/setCurrentPos'
      }),
      handleClickInstitution (institutionCode) {
        this.$router.push({name: 'institutions.show', params: {institutionCode}})
      },
      updateTotalUnreadMessage (institutionCode, totalMessages) {
        for (let i = 0; i < this.groups.length; i++) {
          const index = this.groups[i].institutions.findIndex(n => n.institution_code === `${institutionCode}`)
          if (index === -1) continue
          if (totalMessages > this.groups[i].institutions[index].total_messages) {
            this.groups[i].institutions[index].total_unread_messages = this.groups[i].institutions[index].total_unread_messages + 1
            this.groups[i].institutions[index].total_messages = this.groups[i].institutions[index].total_messages + 1
          }
        }
      },
      getTotalUnreadMessages (institutions) {
        let total = 0
        _.forEach(institutions, n => {
          total += n.total_unread_messages
        })
        return total
      },
      canShowToggleButton (group) {
        if (group.institutions.length === 0) return false
        return CAN_SHOW_TOGGLE_INSTITUTIONS.indexOf(this.$auth.user().authority) !== -1
      },
      async paginate ($state) {
        this.getGroups({offset: this.groups.length, state: $state})
      },
      isShowGroup (employeeCode) {
        return _.findIndex(this.groupEmployeeSelected, n => n === employeeCode) > -1
      },
      handleScroll: _.debounce(function () {
        const pos = document.getElementById('institutions_list').scrollTop
        this.setCurrentPos(pos)
      }, 300)
    },
    mounted () {
      // this.subscribeChatGroup = db.ref(`institutions`)
      // this.subscribeChatGroup.on('child_changed', (data) => {
      //   if (this.$auth.user().is_maker) {
      //     this.updateTotalUnreadMessage(data.key, data.val().total_messages[`${this.$auth.user().company_code}`])
      //   } else {
      //     let total = Object.values(data.val().total_messages).reduce((a, b) => a + b, 0)
      //     this.updateTotalUnreadMessage(data.key, total)
      //   }
      // })
      document.getElementById('institutions_list').scrollTop = this.currentPos
    },
    beforeDestroy () {
      // this.subscribeChatGroup.off()
    }
  }
</script>

<style lang="scss">
    #institutions_list {
        height: calc(100vh - 198px);
        overflow-y: scroll;

        .loading {
            height: 50px;
            line-height: 50px;
            text-align: center;
        }

        > div > .item {
            padding-right: 80px;

            .text {
                font-size: 14px;
            }

            > .badge {
                right: 45px;

                &.no-toggle {
                    right: 15px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/screens/home/institutions.vue